import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import {
    ErrorStatusTypes,
    parseErrorMessage,
} from "components/common/errorsDeclarations";
import * as assegnazioniGanttApi from "api/produzione/assegnazioniGanttApi";

// Import types
import {
    AssegnazioniGanttList,
    AssegnazioniGanttState,
    FiltriAssegnazioniGantt,
} from "./assegnazioniGanttTypes";

// ============================================
// INITIAL STATE
// ============================================

const initialState: AssegnazioniGanttState = {
    assegnazioniList: {
        count: 0,
        page: 0,
        num_pages: 0,
        next: undefined,
        previous: undefined,
        results: [],
        errorsStack: { status: ErrorStatusTypes.OK },
    },
    ordineLavoroSelezionatoId: undefined,
};

// ============================================
// ASYNC THUNKS
// ============================================

export const fetchAssegnazioniGantt = createAsyncThunk(
    "assegnazioniGantt/fetchAssegnazioniGantt",
    async (parametri: FiltriAssegnazioniGantt) => {
        return await assegnazioniGanttApi.fetchAssegnazioniGantt(parametri);
    }
);

// ============================================
// SLICE
// ============================================

export const assegnazioniGanttSlice = createSlice({
    name: "assegnazioniGantt",
    initialState,
    reducers: {
        setOrdineLavoroSelezionatoId: (state, action: PayloadAction<number | undefined>) => {
            state.ordineLavoroSelezionatoId = action.payload;
        },
        resetAssegnazioniGantt: (state) => {
            state.assegnazioniList = initialState.assegnazioniList;
            state.ordineLavoroSelezionatoId = undefined;
        },
    },
    extraReducers: (builder) => {
        // ============================================
        // FETCH (Lista)
        // ============================================
        builder.addCase(fetchAssegnazioniGantt.pending, (state) => {
            state.assegnazioniList.errorsStack = { status: ErrorStatusTypes.PENDING };
        });
        builder.addCase(fetchAssegnazioniGantt.fulfilled, (state, action) => {
            state.assegnazioniList = {
                ...action.payload,
                errorsStack: { status: ErrorStatusTypes.OK },
            };
        });
        builder.addCase(fetchAssegnazioniGantt.rejected, (state, action) => {
            state.assegnazioniList.errorsStack = parseErrorMessage(action.error);
        });
    },
});

// ============================================
// EXPORTS
// ============================================

export const {
    setOrdineLavoroSelezionatoId,
    resetAssegnazioniGantt,
} = assegnazioniGanttSlice.actions;

export const assegnazioniGanttSliceReducer = assegnazioniGanttSlice.reducer;